export function fmtZMW(n) {
  if (n === null || n === undefined || typeof n === "string") {
    // Backend masks restricted money values as strings ("— restricted —") — pass through.
    return typeof n === "string" ? n : "K 0.00";
  }
  const num = Number(n || 0);
  return `K ${num.toLocaleString("en-ZM", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export function fmtUSD(n) {
  if (typeof n === "string") return n;
  const num = Number(n || 0);
  return `$ ${num.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
}

export const MONEY_MASK = "— restricted —";
export function isMasked(v) {
  return typeof v === "string" && v.trim().startsWith("—");
}

export function fmtDate(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
    });
  } catch { return "—"; }
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleString("en-GB", {
      day: "2-digit", month: "short", year: "numeric",
      hour: "2-digit", minute: "2-digit",
    });
  } catch { return "—"; }
}

export function daysFromNow(iso) {
  if (!iso) return null;
  const ms = new Date(iso).getTime() - Date.now();
  return Math.round(ms / (1000 * 60 * 60 * 24));
}

export function exportCSV(rows, filename) {
  if (!rows?.length) return;
  const headers = Object.keys(rows[0]);
  const escape = (v) => {
    if (v == null) return "";
    const s = typeof v === "object" ? JSON.stringify(v) : String(v);
    return `"${s.replace(/"/g, '""')}"`;
  };
  const csv = [headers.join(","), ...rows.map((r) => headers.map((h) => escape(r[h])).join(","))].join("\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}

export const COMPANY = {
  name: "Phizo Inv. Ltd",
  tagline: "Operations Control Room",
  logo: "/phizo-logo.png",
  address: "Kitwe, Zambia",
  currency: "ZMW",
};

export const ROLE_LABEL = {
  luroma_provider: "LUROMA Provider",
  director: "Director",
  admin: "Admin",
  finance: "Finance",
  hr: "HR",
  manager: "Manager",
  staff: "Staff",
  viewer: "Viewer",
};

// Access helpers — mirror backend policy (Admin, HR & Finance can see and edit salary)
export const HR_ROLES = new Set(["admin", "hr", "finance", "director"]);
export const SALARY_VIEW_ROLES = new Set(["admin", "hr", "finance"]);
export const SALARY_EDIT_ROLES = new Set(["admin", "hr", "finance"]);
export function canViewHR(role) { return HR_ROLES.has((role || "").toLowerCase()); }
export function canSeeSalary(role) { return SALARY_VIEW_ROLES.has((role || "").toLowerCase()); }
export function canEditSalary(role) { return SALARY_EDIT_ROLES.has((role || "").toLowerCase()); }

export function can(role, min) {
  const rank = { viewer: 0, staff: 1, hr: 2, manager: 2, finance: 3, admin: 3, director: 4 };
  return (rank[role] ?? -1) >= (rank[min] ?? 99);
}
